import $ from "jquery";

const singleListing = () => {
  const init = () => {
    handlerPopupGuest();
    handlerShowMoreReview();
  };

  const el = {
    main: ".SingleListingContent",
    sidebar: ".right-sidebar.sidebar",
    popupGuest: {
      popup: ".search-guests-wrap",
      input: ".search-guests__group",
      applyBtn: ".apply_guests",
    },
    review: {
      container: ".list-unstyled",
      item: ".list-unstyled .media-content",
    },
  };

  if (!$(el.main).length) return;

  const addPadding = () => {
    $(el.main).css("padding-block", "0 120px");
    $(el.sidebar).css("padding-bottom", "100px");
  };
  const removePadding = () => {
    $(el.main).css("padding-block", "");
    $(el.sidebar).css("padding-bottom", "");
  };

  const handlerPopupGuest = () => {
    const $popupGuest = $(el.popupGuest.popup);

    $(document).on("click", el.popupGuest.input, function (e) {
      e.stopPropagation();
      $popupGuest.show();
      addPadding();
    });

    $(document).on("click", el.popupGuest.applyBtn, function (e) {
      e.stopPropagation();
      $popupGuest.hide();
      removePadding();
    });

    $(document).on("click", function (e) {
      if (
        !$popupGuest.is(e.target) &&
        !$popupGuest.has(e.target).length &&
        !$(el.popupGuest.input).is(e.target) &&
        !$(el.popupGuest.input).has(e.target).length
      ) {
        $popupGuest.hide();
        removePadding();
      }
    });
  };

  const handlerShowMoreReview = () => {
    $(".review-block").each(function () {
      const $block = $(this);
      const $short = $block.find(".review-text-short");
      const $full = $block.find(".review-text-full");
      const $more = $block.find(".review-more");
      const $less = $block.find(".review-less");

      // Only apply toggle if there is full content
      if ($full.length) {
        $more.on("click", function () {
          $short.hide();
          $full.show();
          $more.hide();
          $less.show();
        });

        $less.on("click", function () {
          $full.hide();
          $short.show();
          $less.hide();
          $more.show();
        });
      }
    });
  };

  init();
};

try {
  singleListing();
} catch (e) {
  console.error("Error Single Listing: ", e);
}
